import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconCalendar = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M18.85 4H17V6H18.85C18.91 6 18.96 6 19 6.02V9H20V11H19V18.98C19 18.98 18.91 19 18.85 19H5.15C5.09 19 5.04 19 5 18.98V11H4V9H5V6.02C5 6.02 5.09 6 5.15 6H7V4H5.15C3.95 4 3 4.81 3 5.84V19.17C3 20.2 3.94 21.01 5.15 21.01H18.85C20.05 21.01 21 20.2 21 19.17V5.84C21 4.81 20.06 4 18.85 4Z" }),
            React.createElement("path", { d: "M15 4H9V6H15V4Z" }),
            React.createElement("path", { d: "M4 9V11H5H19H20V9H19H5H4Z" }),
            React.createElement("path", { d: "M7 7H9V6V4V3H7V4V6V7Z" }),
            React.createElement("path", { d: "M15 7H17V6V4V3H15V4V6V7Z" }))));
};
